import {
  message
} from 'antd';
import axios from 'axios'
import { getUserAccessToken } from '../utils/auth';
import { FE_VERSION } from '../config/version';
const { datacellularUrl, wxWorkDomain } = process.env;
const codeMessage = {
  [400]: "请求错误",
  [401]: "登录失效或在其他地方已登录",
  [403]: "拒绝访问",
  [404]: "请求地址出错",
  [408]: "请求超时",
  [500]: "服务器内部错误",
  [501]: "服务未实现",
  [502]: "网关错误",
  [503]: "服务不可用",
  [504]: "网关超时",
  [505]: "HTTP版本不受支持"
}
window.addEventListener('unhandledrejection',(event) => {
  event.preventDefault();
})


axios.interceptors.request.use(config => {
  if (config.url.startsWith(datacellularUrl) || config.url.startsWith(wxWorkDomain)) {
    config.headers['tpa-Access-Token'] = getUserAccessToken();
  }
  config.headers['Access-Token'] = getUserAccessToken();
  config.headers['X-FE-Version'] = FE_VERSION;
  return config
})

axios.interceptors.response.use(function (response) {
  if (response.data && response.data.needRefresh) {
    const tips = '您的前端版本过低，请按 Ctrl+F5 强制刷新页面或清除浏览器缓存后重新登录，页面将在5秒后自动刷新';
    message.error(tips);
    setTimeout(() => {
      window.location.reload(true);
    }, 1000*5);
    return Promise.reject(response);
  }
  return response;
}, function (error) {
  if (error.response && error.response.data && error.response.data.needRefresh) {
    const tips = '您的前端版本过低，请按 Ctrl+F5 强制刷新页面或清除浏览器缓存后重新登录，页面将在5秒后自动刷新';
    message.error(tips);
    setTimeout(() => {
      window.location.reload(true);
    }, 1000*5);
    return Promise.reject(error);
  }
  if (error.response) {
    const text = codeMessage[error.response.status] || '请求发生错误';
    if (text) {
      console.log(error)
      message.error(`${text}`)
    }
  }
  return Promise.reject(error)
});
